import {
    createBaseQueries,
    transformErrorResponse,
    transformSuccessResponse,
    transformRequest,
    buildFormData,
    EXTERNAL_URL
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const { rawExternalApiBaseQuery: govAnnouncementBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

const GovAnnouncementAPI = createApi({
    reducerPath: 'GovAnnouncementAPI',
    baseQuery: govAnnouncementBaseQuery,
    endpoints: (builder) => ({

        GetAllGovCategory: builder.query({
            query: () => ({
                url: `/util/announcement/category`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        GetAllGovAnnouncement: builder.query({
            query: (params) => ({
                url: `/util/announcement`,
                method: 'GET',
                params
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addGovAnnouncement: builder.mutation({
            query: ({ announcementDTO, file }) => ({
                url: '/util/announcement',
                method: 'POST',
                body: buildFormData({ announcementDTO, file })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateGovAnnouncement: builder.mutation({
            query: ({ announcementDTO, file }) => ({
                url: '/util/announcement',
                method: 'PUT',
                body: buildFormData({ announcementDTO, file })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getGovAnnouncementById: builder.query({
            query: (id) => ({
                url: `/util/announcement/${id}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteGovAnnouncement: builder.mutation({
            query: (id) => ({
                url: `/util/announcement/${id}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    }),
});

export const {
    useGetAllGovCategoryQuery,
    useLazyGetAllGovCategoryQuery,
    useGetAllGovAnnouncementQuery,
    useLazyGetAllGovAnnouncementQuery,
    useAddGovAnnouncementMutation,
    useUpdateGovAnnouncementMutation,
    useGetGovAnnouncementByIdQuery,
    useLazyGetGovAnnouncementByIdQuery,
    useDeleteGovAnnouncementMutation
} = GovAnnouncementAPI;

export default GovAnnouncementAPI;
